import { render } from "./UsersDeviceIsSharedTo.vue?vue&type=template&id=2da28f7b&ts=true"
import script from "./UsersDeviceIsSharedTo.vue?vue&type=script&lang=ts"
export * from "./UsersDeviceIsSharedTo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__